import { render, staticRenderFns } from "./MyPassoligs.vue?vue&type=template&id=72f05652"
import script from "./MyPassoligs.vue?vue&type=script&lang=js"
export * from "./MyPassoligs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports